// api
import QuestionApi from '@/api/question.ts'

const getQuestionsAction = async ({ commit }: any, presentationId: number) => {
  const questions = await QuestionApi.getQuestions(presentationId)
  commit('setQuestions', questions)

  return questions
}

const updateQuestionAction = async ({ state }: any, payload: any) => {
  const { presentation } = state
  const { question, updatedProperties } = payload

  await QuestionApi.updateQuestion(question.id, {
    ...updatedProperties,
    presentationId: presentation.id,
  })

  // no need to update questions
  // because application will receive a socket message soon
}

const setQuestionsAction = ({ commit }: any, questions: Array<object>) => {
  commit('setQuestions', questions)
}

export default {
  getQuestionsAction,
  updateQuestionAction,
  setQuestionsAction,
}
